import { useState } from 'react';
import { latestAddresses } from '@/mocks/homepage';

export default function AddressSection() {
  const [copiedId, setCopiedId] = useState<number | null>(null);

  const copyUrl = async (url: string, id: number) => {
    try {
      await navigator.clipboard.writeText(url);
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 2000);
    } catch {
      const textArea = document.createElement('textarea');
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 2000);
    }
  };

  return (
    <section id="addresses" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新可用入口地址
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            以下地址均已通过安全验证，您可放心使用。建议收藏本页以便随时获取最新入口。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {latestAddresses.map((addr) => (
            <div
              key={addr.id}
              className="flex items-center justify-between p-5 rounded-lg bg-background-50 border border-secondary-200/60 hover:border-primary-200 transition-all duration-200 group"
            >
              <div className="flex items-center gap-4 min-w-0">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  addr.status === 'available' ? 'bg-accent-100' : 'bg-secondary-100'
                }`}>
                  <i className={`text-lg ${
                    addr.status === 'available' ? 'ri-check-line text-accent-600' : 'ri-time-line text-secondary-500'
                  }`} />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-800">{addr.label}</p>
                  <p className="text-xs text-foreground-400 truncate">{addr.url}</p>
                  <div className="flex items-center gap-3 mt-1">
                    <span className="text-xs text-accent-600 flex items-center gap-1">
                      <span className="w-1.5 h-1.5 rounded-full bg-accent-500 inline-block" />
                      {addr.status === 'available' ? '可用' : '维护中'}
                    </span>
                    <span className="text-xs text-foreground-400">{addr.speed}</span>
                    <span className="text-xs text-foreground-400">{addr.region}</span>
                  </div>
                </div>
              </div>
              <button
                onClick={() => copyUrl(addr.url, addr.id)}
                className="ml-4 px-4 py-2 rounded-lg bg-primary-50 hover:bg-primary-100 text-primary-600 text-xs font-medium transition-all duration-200 whitespace-nowrap flex-shrink-0 cursor-pointer"
              >
                {copiedId === addr.id ? (
                  <>
                    <i className="ri-check-line mr-1" />
                    已复制
                  </>
                ) : (
                  <>
                    <i className="ri-file-copy-line mr-1" />
                    复制地址
                  </>
                )}
              </button>
            </div>
          ))}
        </div>

        <div className="mt-6 p-4 rounded-lg bg-accent-50 border border-accent-100 flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-information-line text-accent-600" />
          </div>
          <div>
            <p className="text-sm text-foreground-700">
              <strong className="text-foreground-900">温馨提示：</strong>
              建议将本页添加为浏览器书签（快捷键 Ctrl+D / Cmd+D），以便在地址变更时第一时间获取最新入口信息。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}